import {
  UpdateAddJackpotPointType,
  UpdateBetGameSetting,
  UpdateBetGameType,
  UpdateBetSwap,
  UpdateConfigSettingType,
  UpdateJackpotSettingType,
  UpdateSmallWinSetting,
  UpdateSwapType,
} from '@/types';
import { axiosDelete, axiosPatch } from '../AxiosApi';
import { sendRequest } from '../AxiosRequest';

export const updateBetGameSetting = async (updateBetGameSetting: UpdateBetGameSetting) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/update',
    body: { ...updateBetGameSetting },
  };
  return await sendRequest(payload, 'updateBetGameSetting', axiosPatch);
};

export const updateAddJackpotPoint = async (updateAddJackpotPointType: UpdateAddJackpotPointType) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/admin-bet/jackpot-add',
    body: { ...updateAddJackpotPointType },
  };
  return await sendRequest(payload, 'updateAddJackpotPoint', axiosPatch);
};

export const updateSwap = async (updateSwapType: UpdateSwapType[]) => {
  const paylaod = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/admin-bet/swap',
    body: updateSwapType,
  };
  return await sendRequest(paylaod, 'updateSwap', axiosPatch);
};

export const updateSmallWinSetting = async (updateSmallWinSetting: UpdateSmallWinSetting) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/small-setting-update',
    body: { ...updateSmallWinSetting },
  };
  return await sendRequest(payload, 'updateSmallWinSetting', axiosPatch);
};

export const updateConfigSetting = async (updateConfigSetting: UpdateConfigSettingType) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/config',
    body: { ...updateConfigSetting },
  };
  return await sendRequest(payload, 'updateConfigSetting', axiosPatch);
};

export const updateJackpotSetting = async (updateJackpotSetting: UpdateJackpotSettingType) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/jackpot',
    body: { ...updateJackpotSetting },
  };
  return await sendRequest(payload, 'updateJackpotSetting', axiosPatch);
};
